import type React from 'react';
import { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { PublicHeader } from '../components/public-header';
import { TERMS_LAST_MODIFIED, TermsOfUseContent } from './terms-of-use-content';

export const TermsOfUse: React.FC = () => {
  const navigate = useNavigate();
  const headingRef = useRef<HTMLHeadingElement>(null);

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0 });
    headingRef.current?.focus({ preventScroll: true });
  }, []);

  return (
    <div className="min-h-screen bg-background flex flex-col">
      <PublicHeader showSignIn={false} showBack onBack={() => navigate('/')} />

      <main className="flex-1 px-6 py-12">
        <div className="max-w-3xl mx-auto">
          <h1
            ref={headingRef}
            tabIndex={-1}
            className="text-4xl font-bold text-foreground mb-2 outline-none"
          >
            <strong>Terms of Use</strong>
          </h1>
          <p className="text-sm text-muted-foreground mb-10">
            Last Modified: {TERMS_LAST_MODIFIED}
          </p>

          <TermsOfUseContent />
        </div>
      </main>
    </div>
  );
};
